var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tabbar",attrs:{"aria-label":"主导航"}},_vm._l((_vm.items),function(item){return _c('button',{key:item.path,class:['tabbar__item', { 'is-active': _vm.isActive(item) }],on:{"click":function($event){return _vm.go(item.path)}}},[_c('Icon',{attrs:{"type":item.icon,"size":"22"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.label))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64c62e51","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/H5TabBar.vue
// module id = null
// module chunks = 